import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Box } from 'reflexbox';

import { Button, Paragraph, Subheading, tokens } from '@treams/treams-ui';

import BareLayout from '../../../../../../src/packages/kakapo-ui-application/layouts/BareLayout';
import PublicForm from '../../components/authentication/PublicForm';

export default function InvalidNameID() {
	const { t } = useTranslation();
	const history = useHistory();

	return (
		<BareLayout>
			<Formik initialValues={{}} onSubmit={() => {}}>
				{() => (
					<PublicForm>
						<Box textAlign="center">
							<Subheading mb={`${tokens.gap.group}px`}>
								{t('common.errors.invalidNameID.title')}
							</Subheading>
							<Paragraph mb={3}>{t('common.errors.invalidNameID.subtitle')}</Paragraph>
							<Paragraph mb={4}>{t('common.errors.invalidNameID.message')}</Paragraph>
							<Button
								title={t('common.homePage')}
								onClick={() => {
									history.push('/');
								}}
							/>
						</Box>
					</PublicForm>
				)}
			</Formik>
		</BareLayout>
	);
}
